export default __webpack_public_path__ + "static/media/sacs.5d4fb4cc.svg";